function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.15,405.11C478.14,372.8,484.8,328,481,290c-1.88-18.83-5.56-38.57-16.68-54.35-16.2-23-42.94-35.08-63.32-53.65-30-27.32-42.69-67.21-68.21-98C299.48,43.89,247,38.82,197.9,41.19,161,43,101.68,43.7,93,90c-9,48,8,93-28,116S10,277,21,318c9.28,34.58,53.76,40.7,63,76,11,42,75,98,137,94s98-45,124-43c30.13,2.31,62.23,2.22,87.56-16.61A103.94,103.94,0,0,0,455.15,405.11Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.15,405.11C478.14,372.8,484.8,328,481,290c-1.88-18.83-5.56-38.57-16.68-54.35-16.2-23-42.94-35.08-63.32-53.65-30-27.32-42.69-67.21-68.21-98C299.48,43.89,247,38.82,197.9,41.19,161,43,101.68,43.7,93,90c-9,48,8,93-28,116S10,277,21,318c9.28,34.58,53.76,40.7,63,76,11,42,75,98,137,94s98-45,124-43c30.13,2.31,62.23,2.22,87.56-16.61A103.94,103.94,0,0,0,455.15,405.11Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.69,136.06s-19.09-10.61-20.5,13.43-4.95,180.26-4.95,180.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.28,151.61s15.57,34.64,8.5,176",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.57,140.89s-7.3,4.68-11.45-.67,2.81-15.16-3.33-19.36-16.74,2.21-16.74,2.21,8.17,2.4,7.9,6.85-4.19,6.14-4.71,4.19-4.42-11.75-11.05-7.67a16.45,16.45,0,0,0-7.64,10.4S364,135.2,364.91,141s-6.32-1-12.69-1.39-12.16.56-11.75,4.42-.6,10.18-.6,10.18,5.39-4.79,12.39-4.38,6.74,4.87.37,4.5S340.8,160,340.8,160s5.8,9.92,13.18,14.82,10,3.15,10.89-.63-1.12-13.48,3.33-13.22-7.37,16.81-1.68,17.78,10.25-.67,11.75-4.41l1.5-3.74s-2-9.7-1.12-13.48,1.91.11,2.92,4.64,1.64,15.43,3.59,14.9,8.16-8.46,9.62-11.56-8.19-12.62-8.08-14.53,7.56,1.72,8.72,3.71a48.8,48.8,0,0,1,2.28,4.6s4.65-2.92,4.54-11.86S395.57,140.89,395.57,140.89Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.57,140.89s-7.3,4.68-11.45-.67,2.81-15.16-3.33-19.36-16.74,2.21-16.74,2.21,8.17,2.4,7.9,6.85-4.19,6.14-4.71,4.19-4.42-11.75-11.05-7.67a16.45,16.45,0,0,0-7.64,10.4S364,135.2,364.91,141s-6.32-1-12.69-1.39-12.16.56-11.75,4.42-.6,10.18-.6,10.18,5.39-4.79,12.39-4.38,6.74,4.87.37,4.5S340.8,160,340.8,160s5.8,9.92,13.18,14.82,10,3.15,10.89-.63-1.12-13.48,3.33-13.22-7.37,16.81-1.68,17.78,10.25-.67,11.75-4.41l1.5-3.74s-2-9.7-1.12-13.48,1.91.11,2.92,4.64,1.64,15.43,3.59,14.9,8.16-8.46,9.62-11.56-8.19-12.62-8.08-14.53,7.56,1.72,8.72,3.71a48.8,48.8,0,0,1,2.28,4.6s4.65-2.92,4.54-11.86S395.57,140.89,395.57,140.89Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.56,161.87c4.76-5.88,11.78-13.85,17.66-17.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,169s1.22-1.7,3.2-4.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.32,145.68s7.08,10,8.39,20.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.31,151.6s2-1.16,1.24,11.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.48,139.77s4-3.59,1.91-10.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.01,
    y1: 145.83,
    x2: 368.13,
    y2: 140.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,151.22s-9.17-6.93-14.9-7.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.59,122s-.29,10.5-8.48,11-13.26-13.15-21.65-9.86-9.19,18.26-9.19,18.26,8-6.54,12.24-3.24,3.29,8.39,1,7.58-14.78-3.59-15.21,5.83a19.91,19.91,0,0,0,5.21,14.74s8.87-16.57,15.31-13.55-5.32,5.65-10,11.76-7.73,12.57-3.59,14.78,9.79,7.54,9.79,7.54-1.12-8.66,4.06-15.39,9.47-3.42,4.75,2.69-2.37,15.72-2.37,15.72,13.89,1,23.83-3.08,10-7.9,6.79-11.34-14.26-8.06-11-12.35,11.8,18.85,16.65,13.81,6.32-10.72,3.6-14.78l-2.73-4s-11.06-4.62-14.26-8.06,1.42-1.84,6.64.24,16.56,8.87,17.37,6.56-2.91-13.94-5-17.52-18.22-.39-20.06-1.8,6.88-6.4,9.66-6.21a60.1,60.1,0,0,1,6.17.85s.24-6.63-8.8-12.62S421.59,122,421.59,122Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.59,122s-.29,10.5-8.48,11-13.26-13.15-21.65-9.86-9.19,18.26-9.19,18.26,8-6.54,12.24-3.24,3.29,8.39,1,7.58-14.78-3.59-15.21,5.83a19.91,19.91,0,0,0,5.21,14.74s8.87-16.57,15.31-13.55-5.32,5.65-10,11.76-7.73,12.57-3.59,14.78,9.79,7.54,9.79,7.54-1.12-8.66,4.06-15.39,9.47-3.42,4.75,2.69-2.37,15.72-2.37,15.72,13.89,1,23.83-3.08,10-7.9,6.79-11.34-14.26-8.06-11-12.35,11.8,18.85,16.65,13.81,6.32-10.72,3.6-14.78l-2.73-4s-11.06-4.62-14.26-8.06,1.42-1.84,6.64.24,16.56,8.87,17.37,6.56-2.91-13.94-5-17.52-18.22-.39-20.06-1.8,6.88-6.4,9.66-6.21a60.1,60.1,0,0,1,6.17.85s.24-6.63-8.8-12.62S421.59,122,421.59,122Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.37,173.39c-2.65-8.78-5.84-21.23-5.64-29.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.78,183.8s-.87-2.38-2.07-6.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.31,141.56s14.83-.26,26,5.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.77,153.62s.19-2.78,12.43,6.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.45,140.38s-.84-6.5-9.45-9.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.8,
    y1: 149.99,
    x2: 402.55,
    y2: 149.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.06,159.73s-13.19,4.46-17.43,10",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.64,191.9s41.71,27.57,41,134.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.06,184.62s-1.33,12.09-10.83,11.9-14.06-16.42-24.05-13.42-12.33,20.2-12.33,20.2,9.8-6.79,14.43-2.58,3,10,.42,8.84S336,204,334.6,214.84a23,23,0,0,0,4.62,17.51s11.79-18.28,18.95-14.19-6.68,6-12.7,12.63-10.11,13.76-5.54,16.71,10.58,9.63,10.58,9.63S350,247,356.65,239.75s11.25-3.06,5.23,3.55-4.21,17.92-4.21,17.92,15.93,2.41,27.78-1.31,12.27-8.17,8.9-12.45-15.69-10.65-11.47-15.27,11.83,22.85,17.91,17.5,8.3-11.78,5.54-16.71l-2.77-4.93s-12.32-6.38-15.69-10.66,1.81-2,7.64.91,18.28,11.79,19.42,9.21-2-16.36-4.14-20.69-21-2.17-23-4,8.54-6.73,11.73-6.25a70.77,70.77,0,0,1,7,1.57s.91-7.64-8.95-15.4S385.06,184.62,385.06,184.62Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.06,184.62s-1.33,12.09-10.83,11.9-14.06-16.42-24.05-13.42-12.33,20.2-12.33,20.2,9.8-6.79,14.43-2.58,3,10,.42,8.84S336,204,334.6,214.84a23,23,0,0,0,4.62,17.51s11.79-18.28,18.95-14.19-6.68,6-12.7,12.63-10.11,13.76-5.54,16.71,10.58,9.63,10.58,9.63S350,247,356.65,239.75s11.25-3.06,5.23,3.55-4.21,17.92-4.21,17.92,15.93,2.41,27.78-1.31,12.27-8.17,8.9-12.45-15.69-10.65-11.47-15.27,11.83,22.85,17.91,17.5,8.3-11.78,5.54-16.71l-2.77-4.93s-12.32-6.38-15.69-10.66,1.81-2,7.64.91,18.28,11.79,19.42,9.21-2-16.36-4.14-20.69-21-2.17-23-4,8.54-6.73,11.73-6.25a70.77,70.77,0,0,1,7,1.57s.91-7.64-8.95-15.4S385.06,184.62,385.06,184.62Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.34,243.48c-2.23-10.38-4.73-25-3.7-34.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.3,255.82s-.78-2.83-1.81-7.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,206.56s17.14,1.09,29.52,8.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.36,220.52s.49-3.19,13.71,8.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,204.46s-.35-7.58-10-11.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.81,
    y1: 215.76,
    x2: 360.51,
    y2: 214.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.35,227.13S353.71,231,348.3,237",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.9,276s26.86,20.5,29.69,50.9l-5.66-101.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.83,326.21s-20.5-149.15,38.88-149.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.42,204.92c-6.57-3.89-13.83-4-17.39-8.08s3.43-6.17,7.17-4.62,12.41,6,14.05,7,.51-13.23-2.54-18.58-11.38-8.46-15.54-4.09c-8.78,9.22-22.47-2.87-21.53-10.07s-5.79-15-20.23-10.42-9.06,7.07-9.06,7.07,10.26,6.28,16.83,10.17,17.45,7.22,15.12,10.05-8.64,1.1-13.9-3.12S392,165.94,390.47,169.68s-7,14-7,14a153.4,153.4,0,0,1,19.79,4.39c8.79,2.76,10.59,7.59,3.72,8s-19.34-4.78-23.23,1.79-1.22,23.44-1.22,23.44,12.58-8.53,19-8.5,2.31,3.59-4.86,8.21a98.56,98.56,0,0,0-9,6.21L394.21,244s10.79-1.38,15.05-1.08l4.26.3s0-17.54,5-22.74,5.94,6.83,7,9.9-2.14,12.26-2.14,12.26,12.46-6.82,16.5-9.53l4-2.71s-4.66-12.74-7.83-16.38-7.48-3.1-3.83-6.26,9.08-1.5,12.19,3S451.23,224,451.23,224s4.65.75,10.7-6.09S466,208.8,459.42,204.92Zm-57.11,19.31C397.48,221.82,409,217,409,217,413.17,216.39,407.14,226.65,402.31,224.23Zm8.13-22.53c-2.06-1,4.12-3.08,4.12-3.08C423.47,200.33,412.5,202.73,410.44,201.7Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.18,236.53q-1.87,2-3.87,3.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,199c-4.62,9.62-11.6,22.18-20.79,33.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.18,194.15c2.9-6.47,4.38-10.74,4.38-10.74s5.39,2.52,10.61,1.18a20.16,20.16,0,0,1,9.43-.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.93,192.57c1.37-1.18-19.71-11.66-19.71-11.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,198.92s10,4.12,15.52,10.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.72,205.68a83.66,83.66,0,0,0-16.17-1.14,51.91,51.91,0,0,0-16,2.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.25,212.27s11.05,7.2,10.84,16.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.09,188.88s-6.64,4.83-10.87,0S335,174.4,329,170.78s-15.69,3-15.69,3,7.84,1.81,7.84,6-3.62,6-4.22,4.23-4.83-10.87-10.86-6.64a15.51,15.51,0,0,0-6.64,10.26s14.48-2.42,15.69,3-6-.6-12.07-.6-11.47,1.21-10.87,4.83a47,47,0,0,1,0,9.65s4.83-4.82,11.47-4.82,6.64,4.22.6,4.22-10.86,6-10.86,6,6,9.05,13.28,13.27,9.65,2.42,10.26-1.2-1.81-12.68,2.41-12.68-6,16.3-.6,16.9,9.65-1.21,10.86-4.83l1.21-3.62s-2.42-9-1.81-12.67,1.81,0,3,4.22,2.41,14.49,4.22,13.88,7.24-8.45,8.45-11.46-8.45-11.47-8.45-13.28,7.24,1.21,8.45,3a45.67,45.67,0,0,1,2.41,4.22s4.23-3,3.62-11.47S344.09,188.88,344.09,188.88Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.28,210.77c4.17-5.83,10.36-13.74,15.7-17.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.46,217.85s1.06-1.67,2.79-4.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,194.31s7.24,9.06,9.05,18.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.76,200.35s1.81-1.21,1.81,10.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,188.88s3.62-3.62,1.21-10.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321.15,
    y1: 194.92,
    x2: 318.14,
    y2: 190.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.72,200.35s-9.05-6-14.48-6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.3,264.9s19.09-10.6,20.5,13.43c.88,14.85,2.56,80.16,3.72,127.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.72,280.45S369,306.61,370.52,406.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.42,269.74s7.3,4.68,11.46-.67-2.81-15.17,3.33-19.36,16.73,2.21,16.73,2.21-8.16,2.39-7.9,6.85,4.2,6.14,4.72,4.19,4.41-11.76,11-7.68a16.41,16.41,0,0,1,7.64,10.41s-15.42-1.64-16.36,4.16,6.33-1,12.69-1.39,12.17.56,11.76,4.42.6,10.18.6,10.18-5.39-4.79-12.39-4.38-6.74,4.87-.38,4.49,11.83,5.69,11.83,5.69-5.8,9.92-13.17,14.83-10,3.14-10.9-.64,1.13-13.47-3.33-13.21,7.38,16.81,1.69,17.78-10.26-.67-11.76-4.41l-1.5-3.75s2-9.69,1.13-13.47-1.91.11-2.92,4.64-1.65,15.42-3.6,14.9-8.16-8.46-9.62-11.57,8.2-12.62,8.09-14.52-7.57,1.72-8.73,3.7a49.71,49.71,0,0,0-2.28,4.61s-4.64-2.92-4.53-11.87S365.42,269.74,365.42,269.74Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.42,269.74s7.3,4.68,11.46-.67-2.81-15.17,3.33-19.36,16.73,2.21,16.73,2.21-8.16,2.39-7.9,6.85,4.2,6.14,4.72,4.19,4.41-11.76,11-7.68a16.41,16.41,0,0,1,7.64,10.41s-15.42-1.64-16.36,4.16,6.33-1,12.69-1.39,12.17.56,11.76,4.42.6,10.18.6,10.18-5.39-4.79-12.39-4.38-6.74,4.87-.38,4.49,11.83,5.69,11.83,5.69-5.8,9.92-13.17,14.83-10,3.14-10.9-.64,1.13-13.47-3.33-13.21,7.38,16.81,1.69,17.78-10.26-.67-11.76-4.41l-1.5-3.75s2-9.69,1.13-13.47-1.91.11-2.92,4.64-1.65,15.42-3.6,14.9-8.16-8.46-9.62-11.57,8.2-12.62,8.09-14.52-7.57,1.72-8.73,3.7a49.71,49.71,0,0,0-2.28,4.61s-4.64-2.92-4.53-11.87S365.42,269.74,365.42,269.74Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.43,290.72c-4.76-5.89-11.77-13.85-17.65-17.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,297.89s-1.22-1.7-3.2-4.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.67,274.53s-7.07,10-8.38,20.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.68,280.44s-2-1.16-1.23,11.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.51,268.61s-4-3.59-1.91-10.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.98,
    y1: 274.68,
    x2: 392.86,
    y2: 269.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.05,280.07s9.17-6.93,14.89-7.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.4,250.88s.29,10.5,8.48,11,13.27-13.15,21.65-9.86,9.2,18.26,9.2,18.26-8-6.54-12.24-3.24-3.29,8.38-1,7.58,14.78-3.59,15.22,5.82a19.87,19.87,0,0,1-5.22,14.74s-8.86-16.56-15.31-13.54,5.33,5.64,10,11.76S378,306,373.82,308.19s-9.78,7.54-9.78,7.54,1.12-8.66-4.07-15.39-9.46-3.43-4.75,2.69,2.37,15.72,2.37,15.72-13.89.95-23.82-3.08-10-7.9-6.79-11.34,14.25-8.07,10.95-12.35-11.8,18.84-16.65,13.81S315,295.06,317.69,291l2.72-4.05s11.06-4.62,14.26-8.06-1.41-1.84-6.64.24-16.56,8.86-17.36,6.56,2.9-13.94,5-17.52,18.22-.39,20.05-1.81-6.88-6.39-9.65-6.2a60.1,60.1,0,0,0-6.17.85s-.24-6.64,8.79-12.63S339.4,250.88,339.4,250.88Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.4,250.88s.29,10.5,8.48,11,13.27-13.15,21.65-9.86,9.2,18.26,9.2,18.26-8-6.54-12.24-3.24-3.29,8.38-1,7.58,14.78-3.59,15.22,5.82a19.87,19.87,0,0,1-5.22,14.74s-8.86-16.56-15.31-13.54,5.33,5.64,10,11.76S378,306,373.82,308.19s-9.78,7.54-9.78,7.54,1.12-8.66-4.07-15.39-9.46-3.43-4.75,2.69,2.37,15.72,2.37,15.72-13.89.95-23.82-3.08-10-7.9-6.79-11.34,14.25-8.07,10.95-12.35-11.8,18.84-16.65,13.81S315,295.06,317.69,291l2.72-4.05s11.06-4.62,14.26-8.06-1.41-1.84-6.64.24-16.56,8.86-17.36,6.56,2.9-13.94,5-17.52,18.22-.39,20.05-1.81-6.88-6.39-9.65-6.2a60.1,60.1,0,0,0-6.17.85s-.24-6.64,8.79-12.63S339.4,250.88,339.4,250.88Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.62,302.24c2.65-8.78,5.84-21.24,5.64-29.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.21,312.65s.87-2.39,2.07-6.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.68,270.41s-14.83-.27-26,5.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.22,282.46s-.19-2.77-12.42,6.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.54,269.23s.84-6.5,9.46-9.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.2,
    y1: 278.83,
    x2: 358.45,
    y2: 278.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.93,288.58s13.19,4.46,17.43,10",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.36,320.75S399,339.51,389.43,406",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.93,313.47s1.33,12.08,10.83,11.9,14.07-16.43,24.05-13.42,12.34,20.2,12.34,20.2-9.81-6.79-14.44-2.58-3,10-.41,8.84,16.71-5.54,18.1,5.28a23,23,0,0,1-4.62,17.5S410,342.92,402.83,347s6.68,6,12.69,12.62,10.11,13.77,5.54,16.72S410.48,386,410.48,386s.48-10.1-6.14-17.37-11.25-3.07-5.23,3.55,4.22,17.92,4.22,17.92-15.94,2.41-27.78-1.32-12.28-8.17-8.91-12.44,15.69-10.65,11.48-15.28-11.84,22.86-17.91,17.51-8.31-11.78-5.54-16.72l2.76-4.93s12.33-6.38,15.69-10.65-1.8-2-7.64.91-18.27,11.79-19.42,9.21,2-16.36,4.14-20.69,21-2.18,23-4-8.54-6.73-11.72-6.25a68.24,68.24,0,0,0-7,1.57s-.91-7.64,8.95-15.4S375.93,313.47,375.93,313.47Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.93,313.47s1.33,12.08,10.83,11.9,14.07-16.43,24.05-13.42,12.34,20.2,12.34,20.2-9.81-6.79-14.44-2.58-3,10-.41,8.84,16.71-5.54,18.1,5.28a23,23,0,0,1-4.62,17.5S410,342.92,402.83,347s6.68,6,12.69,12.62,10.11,13.77,5.54,16.72S410.48,386,410.48,386s.48-10.1-6.14-17.37-11.25-3.07-5.23,3.55,4.22,17.92,4.22,17.92-15.94,2.41-27.78-1.32-12.28-8.17-8.91-12.44,15.69-10.65,11.48-15.28-11.84,22.86-17.91,17.51-8.31-11.78-5.54-16.72l2.76-4.93s12.33-6.38,15.69-10.65-1.8-2-7.64.91-18.27,11.79-19.42,9.21,2-16.36,4.14-20.69,21-2.18,23-4-8.54-6.73-11.72-6.25a68.24,68.24,0,0,0-7,1.57s-.91-7.64,8.95-15.4S375.93,313.47,375.93,313.47Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.65,372.33c2.23-10.38,4.74-25.05,3.7-34.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.7,384.66s.78-2.83,1.81-7.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,335.41s-17.14,1.09-29.52,8.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.63,349.36s-.48-3.19-13.71,8.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,333.3s.36-7.58,10-11.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.18,
    y1: 344.61,
    x2: 400.48,
    y2: 343.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.65,356s15.63,3.91,21.05,9.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.19,
    y1: 405.67,
    x2: 387.06,
    y2: 353.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.55,406.24c.61-43.5-5.61-100.34-42.26-100.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.57,333.76c6.57-3.88,13.84-4,17.4-8.07s-3.43-6.17-7.17-4.63-12.41,6-14.06,7-.5-13.22,2.54-18.57,11.38-8.46,15.54-4.09c8.78,9.22,22.47-2.87,21.54-10.08s5.79-14.95,20.23-10.41,9.05,7.06,9.05,7.06-10.25,6.29-16.82,10.17-17.46,7.22-15.12,10.05,8.63,1.11,13.9-3.12,20.38-14.27,21.93-10.53,7,14.05,7,14.05a154.27,154.27,0,0,0-19.8,4.4c-8.79,2.76-10.59,7.59-3.72,8s19.35-4.79,23.23,1.78,1.23,23.44,1.23,23.44-12.58-8.52-19-8.49-2.31,3.58,4.86,8.21a100.45,100.45,0,0,1,9,6.21l-6.53,16.72s-10.79-1.38-15-1.08l-4.26.3s0-17.54-5-22.75-5.93,6.84-7,9.91,2.15,12.25,2.15,12.25-12.46-6.82-16.5-9.53l-4-2.71s4.66-12.73,7.82-16.38,7.48-3.09,3.84-6.26-9.09-1.49-12.2,3-6.76,13.31-6.76,13.31-4.65.76-10.69-6.09S295,337.65,301.57,333.76Zm57.11,19.32c4.83-2.41-6.63-7.24-6.63-7.24C347.82,345.23,353.86,355.49,358.68,353.08Zm-8.13-22.53c2.06-1-4.11-3.09-4.11-3.09C337.52,329.18,348.5,331.58,350.55,330.55Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.81,365.37q1.89,2,3.87,3.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.05,327.82c4.61,9.62,11.6,22.17,20.79,33.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.81,323c-2.89-6.47-4.38-10.74-4.38-10.74s-5.38,2.52-10.61,1.18a20,20,0,0,0-9.42-.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.06,321.42c-1.36-1.19,19.71-11.66,19.71-11.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,327.76s-10,4.13-15.52,10.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.27,334.52a83.72,83.72,0,0,1,16.18-1.14,52,52,0,0,1,16,2.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.74,341.12s-11,7.2-10.84,16.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.91,317.73s6.64,4.83,10.86,0S426,303.25,432,299.62s15.69,3,15.69,3-7.85,1.81-7.85,6,3.62,6,4.23,4.22,4.82-10.86,10.86-6.64a15.58,15.58,0,0,1,6.64,10.26s-14.49-2.41-15.69,3,6-.6,12.07-.6,11.46,1.2,10.86,4.82a47.86,47.86,0,0,0,0,9.66s-4.83-4.83-11.47-4.83-6.64,4.23-.6,4.23,10.86,6,10.86,6-6,9-13.27,13.28-9.66,2.41-10.26-1.21,1.81-12.67-2.42-12.67,6,16.29.61,16.9-9.66-1.21-10.87-4.83l-1.2-3.62S432.6,337.64,432,334s-1.81,0-3,4.23-2.42,14.48-4.23,13.88-7.24-8.45-8.44-11.47,8.44-11.46,8.44-13.27-7.24,1.2-8.44,3a46.46,46.46,0,0,0-2.42,4.23s-4.22-3-3.62-11.47S416.91,317.73,416.91,317.73Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.72,339.62c-4.17-5.83-10.36-13.75-15.71-17.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.53,346.7s-1.06-1.68-2.79-4.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,323.16s-7.25,9-9.06,18.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.24,329.2s-1.81-1.21-1.81,10.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,317.73s-3.62-3.62-1.2-10.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 439.84,
    y1: 323.76,
    x2: 442.86,
    y2: 318.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.27,329.2s9.06-6,14.49-6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Form--inject-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 34.78,
    width: 222,
    height: 292.34,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 26.78,
    width: 222,
    height: 292.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "214.6 114.59 63 114.59 63 80.52 259.72 80.52 259.72 114.59 218.26 114.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "75.28 154.89 63 154.89 63 137.28 170.38 137.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "175.04 137.28 259.72 137.28 259.72 154.89 78.61 154.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "228.9 190.53 63 190.53 63 172.92 259.72 172.92 259.72 190.53 232.56 190.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "113.86 297.04 63 297.04 63 207.36 259.72 207.36 259.72 297.04 118.84 297.04",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 207.36,
    width: 196.72,
    height: 15.67,
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "156.51 115.25 156.51 137.31 63 137.31 63 114.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 92.61,
    width: 196.72,
    height: 9.89,
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.41,
    y1: 81.44,
    x2: 194.41,
    y2: 92.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.3,
    y: 83.32,
    width: 13.4,
    height: 6.55,
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.1,
    y1: 102.81,
    x2: 163.1,
    y2: 114.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.23,
    y1: 102.81,
    x2: 204.23,
    y2: 114.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.19,
    y1: 137.31,
    x2: 99.19,
    y2: 114.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.09,
    y1: 137.31,
    x2: 122.09,
    y2: 114.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.06,
    y1: 137.42,
    x2: 147.06,
    y2: 154.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.96,
    y1: 137.18,
    x2: 193.96,
    y2: 190.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "63 154.89 63 172.94 194.03 172.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.35,
    y1: 155.02,
    x2: 112.35,
    y2: 172.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.19,
    y1: 237.63,
    x2: 259.82,
    y2: 237.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.27,
    y1: 237.63,
    x2: 243.86,
    y2: 237.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.27,
    y1: 251.79,
    x2: 259.82,
    y2: 251.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.83,
    y1: 265.89,
    x2: 259.82,
    y2: 265.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.27,
    y1: 265.89,
    x2: 118.84,
    y2: 265.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.05,
    y: 241.53,
    width: 6.65,
    height: 6.65,
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.2,
    y: 241.53,
    width: 6.65,
    height: 6.65,
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.85,
    y: 255.1,
    width: 6.65,
    height: 6.65,
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.32,
    y: 255.1,
    width: 6.65,
    height: 6.65,
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.18,
    y: 255.1,
    width: 6.65,
    height: 6.65,
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.58,
    y: 255.1,
    width: 6.65,
    height: 6.65,
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102.77,
    y1: 251.91,
    x2: 102.77,
    y2: 266.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.44,
    y1: 251.91,
    x2: 138.44,
    y2: 266.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.1,
    y1: 251.91,
    x2: 174.1,
    y2: 266.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.76,
    y1: 251.91,
    x2: 209.76,
    y2: 266.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.27,
    y1: 280.27,
    x2: 259.82,
    y2: 280.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.45,
    y: 269.48,
    width: 6.65,
    height: 6.65,
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.32,
    y: 269.48,
    width: 6.65,
    height: 6.65,
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.18,
    y: 269.48,
    width: 6.65,
    height: 6.65,
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.1,
    y: 269.48,
    width: 6.65,
    height: 6.65,
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.37,
    y1: 266.29,
    x2: 78.37,
    y2: 280.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.44,
    y1: 266.29,
    x2: 138.44,
    y2: 280.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.1,
    y1: 266.29,
    x2: 174.1,
    y2: 280.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 219.28,
    y1: 266.29,
    x2: 219.28,
    y2: 280.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.18,50.4v2.42h-5.49V63.16H134V39.28h9.49V41.7h-6.82v8.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.42,45.05c0-3.65,1.8-6,5.45-6s5.49,2.36,5.49,6V57.39c0,3.62-1.8,6-5.49,6s-5.45-2.39-5.45-6ZM148,57.53c0,2.18.92,3.45,2.83,3.45s2.83-1.27,2.83-3.45V44.91c0-2.15-.88-3.45-2.83-3.45S148,42.76,148,44.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.21,39.28c3.75,0,5.32,1.91,5.32,5.46v1.94c0,2.63-.92,4.27-3,4.92,2.18.64,3,2.42,3,5v3.72a6,6,0,0,0,.48,2.87h-2.69a6.2,6.2,0,0,1-.45-2.9V56.51c0-2.7-1.26-3.55-3.48-3.55h-1.87v10.2h-2.66V39.28Zm-.68,11.26c2.11,0,3.37-.68,3.37-3.28V45c0-2.15-.78-3.28-2.76-3.28h-2.59v8.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.12,63.12h-2.55l-4-19v19h-2.32V39.28H176l3.92,19.07,3.79-19.07h3.71V63.16h-2.52V44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.83,
    y1: 74.85,
    x2: 144.49,
    y2: 74.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.74,
    y1: 74.85,
    x2: 119.18,
    y2: 74.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.59,
    y1: 74.85,
    x2: 209.33,
    y2: 74.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.3,
    y1: 74.85,
    x2: 260.02,
    y2: 74.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "230.94 412.55 305.16 409.5 345.69 458.76 245.6 467.48 230.94 412.55",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.93 446.47 326.16 440.88 331.45 447.54 248.16 453.87 245.93 446.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.52 438.47 320.41 433.63 322.86 436.72 244.55 441.88 243.52 438.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.57 432 315.73 427.73 318 430.59 242.51 435.13 241.57 432",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.56 415.37 303.6 412.45 313.64 425.1 240.7 429.11 236.56 415.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.92 426.52 311.75 422.72 313.64 425.1 240.7 429.11 239.92 426.52",
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "289.33 443.31 286.94 439.08 322.86 436.72 326.16 440.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.7 449.02 327.99 443.18 329.53 445.11 247.35 451.17 246.7 449.02",
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 277.06,
    y1: 451.46,
    x2: 275.93,
    y2: 449.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.26 450.46 271.09 450.03 271.71 451.44 265.84 451.89 265.26 450.46",
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.02,
    y1: 445.99,
    x2: 286.71,
    y2: 443.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.77,
    y1: 447.23,
    x2: 269.69,
    y2: 444.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.23,
    y1: 437.61,
    x2: 312.2,
    y2: 441.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.43,
    y1: 438.19,
    x2: 303.19,
    y2: 442.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.67,
    y1: 438.81,
    x2: 288.82,
    y2: 435.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.92,
    y1: 440.09,
    x2: 267.44,
    y2: 430.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "320.41 433.63 318 430.59 268.81 433.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302.04,
    y1: 434.77,
    x2: 300.02,
    y2: 431.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.96,
    y1: 420.58,
    x2: 239.18,
    y2: 424.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308.35,
    y1: 418.56,
    x2: 238.51,
    y2: 421.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.8,
    y1: 416.6,
    x2: 237.87,
    y2: 419.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.05 419.7 298.32 419.59 299.01 420.55 296.72 420.66 296.05 419.7",
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.79 420.36 285.12 420.24 285.73 421.22 283.39 421.34 282.79 420.36",
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.67 417.96 292.94 417.85 293.59 418.79 291.31 418.9 290.67 417.96",
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.08 418.56 280.4 418.45 280.97 419.41 278.64 419.52 278.08 418.56",
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.78 419.15 268.15 419.04 268.64 420.01 266.26 420.12 265.78 419.15",
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.03 419.76 255.44 419.65 255.86 420.63 253.43 420.75 253.03 419.76",
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.96,
    y1: 419.2,
    x2: 293.57,
    y2: 417.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.61,
    y1: 419.8,
    x2: 281.37,
    y2: 417.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.99,
    y1: 420.42,
    x2: 268.92,
    y2: 418.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.09,
    y1: 421.06,
    x2: 256.19,
    y2: 418.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 305.26,
    y1: 414.66,
    x2: 237.24,
    y2: 417.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.5 415.59 299.71 415.49 300.38 416.39 298.17 416.5 297.5 415.59",
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.9 416.54 279.18 416.43 279.74 417.36 277.44 417.47 276.9 416.54",
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.76 417.09 267.09 416.99 267.58 417.93 265.23 418.04 264.76 417.09",
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.75 417.83 251.15 417.72 251.53 418.68 249.12 418.79 248.75 417.83",
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.74,
    y1: 416.78,
    x2: 300.31,
    y2: 414.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.35,
    y1: 417.75,
    x2: 280.17,
    y2: 415.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.9,
    y1: 418.33,
    x2: 267.87,
    y2: 416.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.74,
    y1: 419.1,
    x2: 251.92,
    y2: 417.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.33,456.6l-.33-.55,2.36-.19-1.42-2.31,1.13-.09,3.35,5.42-4.13.35-.33-.57,3-.25-1.23-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.66,458c.51.85,0,1.47-1.56,1.61s-2.74-.35-3.22-1.21l-1.6-2.84c-.46-.81,0-1.41,1.59-1.53s2.65.34,3.12,1.15Zm-2.81-2.76a1.62,1.62,0,0,0-1.67-.67c-.83.06-1.05.38-.77.87l1.65,2.89a1.64,1.64,0,0,0,1.71.71c.83-.07,1.06-.41.77-.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.17,460c-1.67.14-2.61-.26-3.05-1.1l-.25-.45c-.32-.61-.12-1,.7-1.25a2.11,2.11,0,0,1-1.93-1l-.45-.84a1.37,1.37,0,0,0-.55-.63l1.17-.1a1.48,1.48,0,0,1,.54.64l.46.85c.34.62,1,.77,2,.69l.82-.06-1.27-2.31,1.14-.1,3.07,5.5ZM294,457.33c-.92.08-1.39.28-1.07.89l.29.53c.27.51.76.74,1.64.67l1.15-.09-1.14-2.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.82,455.08l1.12-.09,4,4.25-2.28-4.4,1-.08,2.9,5.54-1.66.14-4-4.32.55,4.62-1.68.14-2.71-5.59,1.1-.09,2.2,4.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 332.08,
    y1: 448.72,
    x2: 299.11,
    y2: 451.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 291.88,
    y1: 451.82,
    x2: 271.2,
    y2: 453.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 265.45,
    y1: 453.86,
    x2: 248.41,
    y2: 455.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,255.33a136.14,136.14,0,0,0-20.67,8c-11,5.34-32.66,13.34-43,17.34S219.67,295,217.67,300,207,326.33,207,326.33,188.67,355,184,362s-11,16.67-11.33,25.67,4.66,14,16.33,14,16.67-4,22.33-10,24-35.34,26.67-38.67,10-16,10-16,3.67,33,3.67,43.33v24.34h105s5-36.67,6-39.67,8.66-24.67,8.66-24.67S399,385,403.62,391s17.81,18.64,30.73,13.58,10.27-18.92,3.27-35.58-19.29-45-19.29-46.35-5-21-25.33-36.34-40.33-19-45-21.33S328.33,255.33,300,255.33Z",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.67,315.33l13,20.34S237,324.67,230.33,323",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.67,335.67,240,333s-7-4-12.67-2.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.54,287c.75,5.49,2.48,12.31,6.46,17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,278s-.07,1.91.11,4.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.65,308a30.06,30.06,0,0,0,3,2.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.33,293a44.27,44.27,0,0,0,7.93,13.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.17,367.48c-2.27,3.69-4.42,6.67-6.17,8.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,334.33s-7.75,17.52-15,30",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.92,378.45c-1,1.21-1.77,2.22-2.25,2.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.67,363.33S336.53,370.47,332,376",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.33,340.33S386,317,386.67,315",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.55,331.34c4.36-3.53,10.91-8,17.45-9.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.33,336s1.19-1.23,3.19-3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.67,318.33a81,81,0,0,0-12,7.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.67,367.67a18.84,18.84,0,0,1,18,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.67,363.33s11.66-2.33,20.33,3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,367.33a18.63,18.63,0,0,1,15-4.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.64,363.45a28.5,28.5,0,0,1,2.36,1.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.67,359.67a16.24,16.24,0,0,1,5.47,1.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.67,264s-3,12.67-2,22,11.33,23.67,20,27,24.66-6.33,30.33-12,6-23.67,6-23.67-8.64-18.66-27-24S297.67,264,297.67,264Z",
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.6,261.39s1.74,5.21-1.61,11.8-9.82,12.16-11.56,11.59,5.41-24.42,5.41-24.42S363.59,257.69,366.6,261.39Z",
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.06,242.35s-3.29,4.39-2.2,11.71,5.49,14.63,7.32,14.63,2.56-24.87,2.56-24.87S297.08,239.79,293.06,242.35Z",
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.55,251.86s-2.56,22.32.36,31.47,8.78,23.41,17.93,27.07,30-12.07,33.29-18.29,12.44-32.56,12.44-32.56a23.92,23.92,0,0,0,3.3-22.69c-4.76-13.17-30.37-21.22-41-20.85s-21.22,9.15-21.95,16.1S298.55,251.86,298.55,251.86Z",
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.33,265.4s-8.05-9.88-15.37-6.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.13,269.79s11-2.56,16.1,2.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.06,267.6s2.35,7,11.89,6.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.4,277.47s2.2,4.76,12.44,2.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.37,284.13a6.4,6.4,0,0,0,.6,4.37c1.19,1.79,4.17,4.37,6.36,4.37s6.76-.79,7.95-2a14.31,14.31,0,0,0,2-2.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.4,290.69s5,5.76,9.15,7.15,11.92-1,14.11-1.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.86,226.68c-.34-2.4,1.37-5.83,1.71-7.88s-2.4-5.83-4.79-8.91a13.78,13.78,0,0,1-2.75-8.56c0-2.06-2.39-3.77-4.45-5.14a38.24,38.24,0,0,1-6.85-5.83c-1.37-1.71-7.19-1.37-8.22-1.37s-5.48-3.76-8.22-5.13-8.22,1-8.22,1-6.51-3.08-7.88-3.08-7.2,2.4-7.2,2.4a30.57,30.57,0,0,1-6,1.87,6.42,6.42,0,0,0-1.14-.19c-.77-1-7.62,3.11-7.62,3.11l-6.16,1-2.29,3.71c-2.19.24-7.32,1.06-7.68,3.57-.46,3.2,0,4.57-1.37,6.39s-6.39,1.37-5,5.48,4.56,7.31.45,9.6-6.39,6.39-4.11,8.67,4.11,5.48,3.66,7.31-.92,5.94.91,6.85a32.51,32.51,0,0,1,4.57,3.2l2.28,5,1.37,3.2s2.28-7.31,4.11-8.22,0,3.2,3.66,3.2,7.3-17.36,10-17.82,11,15.08,19.19,15.08S354.13,238,358.25,238s.91,17.35.91,21,.91,7.3.91,8.68,4.57-6.4,7.77-8.23c.88-.5,1.94-1.11,3.05-1.81,0,.16-.05.25-.05.25s11.31-7.2,12.68-9.59.34-4.46.34-6.51,1.37-3.77,1.71-6.85S384.2,229.07,383.86,226.68Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 467.59,
    y1: 404.59,
    x2: 27,
    y2: 404.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.69,375.44s-12.49-4.59-21.47-1-30.06,12.12-44.41,14.81A187.14,187.14,0,0,1,313,391.94c-12.12-.45-18.85,1.35-21.54,3.59s-12.56,14.8-11.67,16.15,1.89,1.86,6.29.9c1.75-.39,6.73-5.83,6.73-5.83l9-4s-9.42,10.32-8.08,11.66,3.59-.45,5.39-1.79,5.38-4.49,5.38-4.49l8.08-3.59S304,410.33,304,413s2.09,1.1,5.65-.32a41,41,0,0,0,4.81-3.55l6.75-1.9a29.67,29.67,0,0,0,14.13,3.36,21.63,21.63,0,0,0,14-5.22s31.41,4.49,47.11,3.14,35.44.45,43.52-5.38-2.24-21.09-3.14-22.44",
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.87,412.92s1.67-4.81,3.34-6.9,9.4-7.1,12.12-8.56a30.63,30.63,0,0,1,3.34-1.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.76,
    y1: 402.71,
    x2: 309.65,
    y2: 397.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.53,
    y1: 404.5,
    x2: 319.89,
    y2: 400.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.69,375.44c-6.67-1.59-16.09-3.15-21.47-1-8,3.19-25.48,10.26-39.35,13.69a12.38,12.38,0,0,1,3.21,7.87,30.6,30.6,0,0,1-1.48,10.8c10.57,1.19,26.17,2.57,35.83,1.74,15.7-1.35,35.44.45,43.52-5.38s-2.24-21.09-3.14-22.44",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.8,374.09c.84-2.27,7-7.7,15.29-6.25s17.7,10.66,23.08,17.74,9.67,9,9.67,9l-6.34,19.37s-3.9-.94-11.22-2.8-23.7-4.28-31.23-6.62-10.74-10.44-9.1-18a45.08,45.08,0,0,1,4.25-12.06",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.17,385.58c-.57-.74-1.18-1.5-1.82-2.28-4.69,1.87-10.64,5.32-13.79,11.4S202.39,405.8,203,409c4,.76,7.69,1.48,10.26,2.13,7.32,1.86,11.22,2.8,11.22,2.8l6.34-19.37S226.54,392.67,221.17,385.58Z",
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.58,404.5c-.42,3-1.34,6.43,3,8.33s8.66,6.59,11.39,7.69A41.06,41.06,0,0,0,243.24,423c2.78.18,6.21,1.09,11.66-.43s5.3-2.92,5.3-2.92,3.4.13,5.08-.7.5-2.91-1.54-3.73-4.54-1.92-4.54-1.92,3.1-2.86,2.32-3.57l-.77-.71s3.58.42,3.89-.72-1.94-6.18-2.84-10.42-2.79-3.67-6.24-4.35-8.15.19-14.35-1.13-15.18.9-18.73,1.84",
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.79,375.65l5.66,20,4.52,2.15-6.7-23.16a1.8,1.8,0,0,0-2.44-1.16h0A1.81,1.81,0,0,0,242.79,375.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,394.12s9.9,5.28,10.58,5.55c.47.19,4.88,7.56,6.28,11.1.65,1.62-.08,2.55-1.6,3.39l-2.05-.83-12.31-7.75-4.51-2.15",
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.09,411.37s9.64,5.73,11.67,6.78,9.44,1.53,9.44,1.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.48,417s8.09,4.46,9.68,5,5,1.48,5,1.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "172.84 454.17 209.76 420.21 128.42 414.96 172.84 454.17",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.28 447.33 187.9 431.58 168.65 430.42 171.28 447.33",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.08 358.8 179.85 364.19 172.84 454.17 50 448.24 58.08 358.8",
    style: {
      fill: "#a6a6a6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.54,442.25c7.2-1.06,19.35-3.89,39.87-10.53,48.85-15.81,55-60,89.44-67.53L58.08,358.8Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.12,
    cy: 404.42,
    rx: 9.34,
    ry: 7.18,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.82aac6e23ef006f5924d2915ef37a3d5.svg";
export { ForwardRef as ReactComponent };